<script>
import FormElements from '@vvg/forum/js/mixins/formElements.js'
import {Link, useForm} from "@inertiajs/vue3";

export default {
	components: {Link},
	mixins: [FormElements],
	props: {
		forum: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			form: useForm({
				id: null,
				title: '',
				description: '',
				images: null,
				forum_id: this.$props.forum.id,
			})
		}
	},
	methods: {
		setTopic(topic) {
			this.form.defaults(topic);
			this.form.reset();
		}
	}
}
</script>

<template>
	<Input
		type="text"
		label="Titel"
		v-model="form.title"
		name="title"
		:form="form"
		required
	/>
	<CkEditor
		label="Beschrijving"
		v-model="form.description"
		name="description"
		:form="form"
		required
	/>
	<Asset
		label="Afbeeldingen"
		v-model="form.images"
		name="images"
		:form="form"
		multiple
	/>


</template>